import createReactComponent from '../createReactComponent';
export default createReactComponent('trending-down', 'IconTrendingDown', [
  ['path', { d: 'M3 7l6 6l4 -4l8 8', key: 'svg-0' }],
  ['path', { d: 'M21 10l0 7l-7 0', key: 'svg-1' }],
]);
